export const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const ENTITY_FIRST_NAME = process.env.REACT_APP_ENTITY_FIRST_NAME;

export const ENTITY_LAST_NAME = process.env.REACT_APP_ENTITY_LAST_NAME;

export const ENTITY_FULL_NAME = process.env.REACT_APP_ENTITY_FULL_NAME;
